import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-undo-gray",
  "use": "icon-undo-gray-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-undo-gray\"><path d=\"M761.856 1024c113.728-206.048 132.896-520.32-313.856-509.824l0 253.824-384-384 384-384 0 248.384c534.976-13.952 594.56 472.224 313.856 775.616z\" fill=\"#515151\" p-id=\"4402\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol